module.exports = __webpack_public_path__ + "img/fullscreen.a704a9ef.svg";